export const ROUTER_ENTERPRISE = "/enterprise"
//export const ROUTER_GROUP = "/group"
export const ROUTER_GROUP = "/enterprise"

export const ROUTER_PRODUCT = "/product"